module.exports = __webpack_public_path__ + "img/SliderBar_106px.8101337f.svg";